import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeadertestComponent } from './headertest/headertest.component';



@NgModule({
  declarations: [HeadertestComponent],
  imports: [
    CommonModule
  ],
  exports: [HeadertestComponent] //新添加的部分
})
export class TestmModule { }
